import styled from 'styled-components';
import { fonts } from '@/template/styles';

export const Container = styled.div`
  .label {
    font-size: ${fonts.small};
    margin-bottom: 0.3rem;
  }
`;
